import { render } from "./SiteFooterView.vue?vue&type=template&id=6b75e580&scoped=true&ts=true"
import script from "./SiteFooterView.vue?vue&type=script&lang=ts"
export * from "./SiteFooterView.vue?vue&type=script&lang=ts"

import "./SiteFooterView.vue?vue&type=style&index=0&id=6b75e580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b75e580"]])

export default __exports__